// extracted by mini-css-extract-plugin
module.exports = {"icons":"_3uWlbBg76B_vZ7rqEkuupF","counterFake":"_3Qyu_I3ucujb-05wjcIJMB","counter":"_2ZOFm6nM5RfoQzImAGn3o5"};